import api from '../../../core/api/api';

/**
 * Servicio de la feature "Verificación de OME" (flujo PAMI).
 *
 * Encapsula las llamadas a SugiAPI para la bandeja "OME por verificar".
 * Los métodos devuelven response.data y NO capturan el error: lo propagan
 * para que el hook/componente que los invoca lo maneje (convención del proyecto).
 */
export const verificacionOmeService = {
  /**
   * Lista los indicadores de verificación de OME pendientes.
   * @param {string} [estado] Filtro opcional por estado (ej. 'pendiente').
   * @returns {Promise<Array>} Lista de verificaciones de OME.
   */
  listarPendientes: async (estado) => {
    const params = estado ? { estado } : {};
    const response = await api.get('/VerificacionOme/ListarPendientes', { params });
    return response.data;
  },

  /**
   * Resuelve una verificación de OME indicando si quedó verificada o no.
   * @param {number|string} idVerificacionOme Identificador de la verificación.
   * @param {boolean} omeVerificada true si la OME quedó verificada, false si no.
   * @param {number|null} [idTipoEstudio] Tipo de estudio elegido al verificar (solo si OME OK).
   *   Viaja al bot para que el flujo PAMI no le pida el estudio al paciente.
   * @returns {Promise<{idVerificacionOme: number, estado: string, yaResuelta: boolean}>}
   */
  resolver: async (idVerificacionOme, omeVerificada, idTipoEstudio = null) => {
    const response = await api.post('/VerificacionOme/Resolver', {
      idVerificacionOme,
      omeVerificada,
      idTipoEstudio,
    });
    return response.data;
  },

  /**
   * Obtiene los tipos de estudio para que el recepcionista elija cuál se realizará
   * al verificar la OME. Reutiliza el endpoint estándar de SugiAPI.
   * @returns {Promise<Array>} Lista de tipos de estudio.
   */
  listarTiposEstudio: async () => {
    const response = await api.get('/TiposEstudios/ObtenerTiposEstudios', {
      params: { ordenarPorFrecuencia: true },
    });
    return response.data;
  },
};

export default verificacionOmeService;
